module.exports = __webpack_public_path__ + "static/media/slide-2.13724e00.png";